
import * as  _ from 'lodash';
import * as Promise from 'promise-polyfill';

if (!window['Promise']) {
    window['Promise'] = Promise;
}
//兼容函数

if (!Array.isArray) {
    Array.isArray = function (arg: any[]): arg is Array<any> {
        return Object.prototype.toString.call(arg) == "[object Array]"
    }
}

if (!Array.prototype.includes) {
    Array.prototype.includes = function <T>(target: T, fromIndex?: number) {
        var _array = this;
        return _.includes(_array, target, fromIndex);
    }
}

if (!Array.prototype.find) {
    Array.prototype.find = function (predicate: (value: any, index: number, obj: Array<any>) => boolean) {
        var _array = this;
        return _.find(_array, predicate, this);
    }
}
if (!Array.prototype.every) {
    Array.prototype.every = function (predicate) {
        var _array = this;
        return _.every(_array, predicate);       
    };
}
if (!Array.prototype.filter) {
    Array.prototype.filter = function (predicate ) {
        var _array = this;
        return _.filter(_array, predicate, this);     
    };
}
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (predicate) {
        var _array = this;
        return _.forEach(_array, predicate, this);  
    };
}
if (!Array.prototype.map) {
    const _map_by_lodash: any = function (callbackfn) {
        var _array = this;
        return _.map(_array, callbackfn, this);
    }
    Array.prototype.map = _map_by_lodash;
}
if (!Array.prototype.some) {
    Array.prototype.some = function (predicate) {
        var _array = this;
        return _.some(_array, predicate);
    };
}


// WEBPACK FOOTER //
// ./src/normalize.ts